import { AxiosRequestConfig } from "axios";

export class MockRouteMatcher {
    public static isMethodAndPathMatch(method: string, path: string, request: AxiosRequestConfig) {
        if (request.method !== method) {
            return false;
        }

        if (!request.url) {
            return false;
        }

        return request.url === path;
    }
}
